import { actionSyncUpdateHash } from '../actions'
import { actions as adActions } from '../features/Ads'
import { actions as newsActions } from '../features/News'
import {
    SERVERS_UPDATE_SERVERLIST,
    SYNC_UPDATE_ADS_TIMESTAMP,
    SYNC_UPDATE_NEWS_HASH,
} from '../constants'

const SyncMiddleware = store => next => (action) => {
    switch (action.type) {
        case SERVERS_UPDATE_SERVERLIST: {
            const result = next(action)
            store.dispatch(actionSyncUpdateHash())
            return result
        }

        // Update news when there are new news
        case SYNC_UPDATE_NEWS_HASH: {
            const oldHash = store.getState().sync.news
            const result = next(action)
            const newHash = store.getState().sync.news
            if (oldHash !== newHash) {
                store.dispatch(newsActions.outdated())
            }
            return result
        }

        // Update ads when there are new ads
        case SYNC_UPDATE_ADS_TIMESTAMP: {
            const oldHash = store.getState().sync.ads
            const result = next(action)
            const newHash = store.getState().sync.ads
            if (oldHash !== newHash) {
                store.dispatch(adActions.outdated())
            }
            return result
        }

        default:
            return next(action)
    }
}

export default SyncMiddleware



// WEBPACK FOOTER //
// ./src/middlewares/SyncMiddleware.js